import { BaseResourceStorage } from '../../models/base-resource.storage';
import { EmendaParlamentar } from './emenda-parlamentar.model';

export class EmendaParlamentarStorage extends BaseResourceStorage {
  constructor(
    public id?: number,
    public visivel_transparencia?: boolean,
    public emenda?: EmendaParlamentar,
  ) {
    super();
  }

  static converteJson(json: any): EmendaParlamentarStorage {
    return Object.assign(new EmendaParlamentarStorage(), json);
  }
}
